import { IDepartamento } from "../interfaces/IDepartamento";
import api from './Api';

class DepartamentoService {
    async obterTodos(): Promise<IDepartamento[]> {
        const { data: result } = await api.get<IDepartamento[]>('Departamento');
        return result;
    }

    async criar(nome: string, descricao?: string): Promise<IDepartamento> {
        const { data: result } = await api.post<IDepartamento>('Departamento', { nome, descricao });
        return result;
    }
}

export default new DepartamentoService();
